/* eslint-disable prettier/prettier */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider, responsiveFontSizes } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Material Dashboard 2 React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// Material Dashboard 2 React Dark Mode themes
import themeDark from "assets/theme-dark";
import themeDarkRTL from "assets/theme-dark/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import "./main.css";
// Material Dashboard 2 React routes
import routes from "routes";
import { store } from "store/store";
// Material Dashboard 2 React contexts
import { useMaterialUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brandWhite from "assets/images/LogoESF.png";
import brandDark from "assets/images/LogoESF.png";
import brandWhite2 from "assets/images/LogoGMF3.png";
import brandDark2 from "assets/images/LogoGMF3.png";
import brandDarksmall from "assets/images/LogoESFsmall.png";
import brandWhitesmall from "assets/images/LogoESFsmall.png";
import SignIn from "layouts/authentication/sign-in";
import ModificarUsuario from "layouts/usuarios/modificarPermisos";
import ModificarRol from "layouts/roles/modificarPermisos";
import SolicitudPublica from "layouts/solicitudes/regsitraSolicitudUser";
import DetallesSolicitud from "layouts/solicitudes/detallesSolicitud";
import CalendarioCitas from "layouts/tav/calendario/calendarioCitas";
import Perfil from "layouts/usuarios/verUsuario/usuario";
import { Toaster } from "react-hot-toast";
import _ from "lodash";
import VersionChecker from "VersionChecker";
import ModalCambioPassword from "CambioPassword";

export default function App() {
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    direction,
    layout,
    openConfigurator,
    sidenavColor,
    transparentSidenav,
    whiteSidenav,
    darkMode,
  } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();
  const [routesState, setroutesState] = useState([]);
  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    let lastRatio = 0;
    let lastWidth = 0;

    const aplicarFontSize = () => {
      const escala = Math.round(window.devicePixelRatio * 100);
      const width = window.innerWidth;
      // Salir si no cambió nada
      if (escala === lastRatio && width === lastWidth) return;
      lastRatio = escala;
      lastWidth = width;

      let fontSize;

      // ✅ Solo aplicar escalado si está dentro del rango 800–1920
      if (width >= 800 && width <= 1920) {
        // Base por resolución
        if (width >= 1800) fontSize = 16;
        else if (width >= 1500) fontSize = 14;
        else if (width >= 1200) fontSize = 13;
        else if (width >= 1000) fontSize = 12;
        else fontSize = 12;

        // Ajuste por escala del sistema
        if (escala === 125) fontSize -= 1;
        else if (escala === 150) fontSize -= 2;
        else if (escala === 175) fontSize -= 3;
        else if (escala >= 200) fontSize -= 4;

        // Límite inferior
        if (fontSize < 8) fontSize = 8;
      } else {
        // Fuera del rango: usar tamaño fijo
        fontSize = 9;
      }

      const final = `${fontSize}px`;
      if (document.documentElement.style.fontSize !== final) {
        window.requestAnimationFrame(() => {
          document.documentElement.style.fontSize = final;
        });
      }
    };

    // Ejecutar al cargar
    aplicarFontSize();

    // Recalcular cada 500ms (detecta cambios de zoom/resolución)
    const interval = setInterval(aplicarFontSize, 500);

    return () => clearInterval(interval);
  }, []);

  const usuarioPermisos = store.getState().login?.usuario?.permisos;
  useEffect(() => {
    setroutesState([]);
    var routessss = [];
    _.map(routes, (route) => {
      const tienePermiso = _.find(usuarioPermisos, { idPermiso: route?.idPermiso });
      if (tienePermiso) {
        routessss.push(route);
      }
    });
    setroutesState(routessss);
  }, [usuarioPermisos]);

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });
  };
  const configsButton = (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.25rem"
      height="3.25rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="small" color="inherit">
        settings
      </Icon>
    </MDBox>
  );

  //ejemplo
  var brandd = brandWhite;
  if ((transparentSidenav && !darkMode) || whiteSidenav) {
    if (miniSidenav) {
      brandd = brandDarksmall;
    } else {
      brandd = brandDark;
    }
  } else {
    if (miniSidenav) {
      brandd = brandWhitesmall;
    } else {
      brandd = brandWhite;
    }
  }
  var brandd2 = brandWhite2;
  if ((transparentSidenav && !darkMode) || whiteSidenav) {
    if (miniSidenav) {
      brandd2 = brandDarksmall;
    } else {
      brandd2 = brandDark2;
    }
  } else {
    if (miniSidenav) {
      brandd2 = brandWhitesmall;
    } else {
      brandd2 = brandWhite2;
    }
  }
  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={darkMode ? themeDarkRTL : themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brandd}
              brand2={brandd2}
              brandName=""
              routes={routesState}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            {configsButton}
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routesState)}
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <ThemeProvider theme={darkMode ? themeDark : theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={brandd}
            brand2={brandd2}
            brandName=""
            routes={routesState}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Toaster
        toastOptions={{ style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" } }}
      />
      <VersionChecker />
      <ModalCambioPassword />
      <Routes>
        {getRoutes(routesState)}
        <Route exact path="/" element={<SignIn />} />
        <Route exact path="/modificarUsuario" element={<ModificarUsuario />} />
        <Route exact path="/modificarRol" element={<ModificarRol />} />
        <Route exact path="/registrar" element={<SolicitudPublica />} />
        <Route exact path="/detalles" element={<DetallesSolicitud />} />
        <Route exact path="/detallesE" element={<DetallesSolicitud />} />
        <Route exact path="/calendarioCitas" element={<CalendarioCitas />} />
        <Route exact path="/perfil" element={<Perfil />} />
      </Routes>
    </ThemeProvider>
  );
}
